module.exports = __webpack_public_path__ + "static/media/home-exchange-img-1.20618925.svg";